// Column visibility preferences for the submissions table (prompt 41).
// Received, Problem Summary, and the select/actions columns are always
// visible — only these can be toggled.

export const STORAGE_KEY = 'cx_column_prefs';

export const HIDEABLE_COLUMNS = [
  { key: 'who', label: 'Name / Email' },
  { key: 'severity', label: 'Severity' },
  { key: 'sentiment', label: 'Sentiment' },
  { key: 'status', label: 'Status' },
  { key: 'assigned_to_name', label: 'Assigned To' },
  { key: 'follow_up', label: 'Follow-Up' },
];

export function defaultVisibility() {
  return Object.fromEntries(HIDEABLE_COLUMNS.map((c) => [c.key, true]));
}

// `storage` is injectable so the helpers can be unit-tested without a DOM.
export function loadColumnPrefs(storage = window.localStorage) {
  const defaults = defaultVisibility();
  try {
    const raw = storage.getItem(STORAGE_KEY);
    if (!raw) return defaults;
    const parsed = JSON.parse(raw);
    for (const [key, value] of Object.entries(parsed || {})) {
      if (key in defaults && typeof value === 'boolean') {
        defaults[key] = value;
      }
    }
    return defaults;
  } catch {
    return defaults;
  }
}

export function saveColumnPrefs(prefs, storage = window.localStorage) {
  try {
    storage.setItem(STORAGE_KEY, JSON.stringify(prefs));
  } catch {
    // Storage blocked or full — prefs just won't persist this session.
  }
}
